/**
 * Mobile Filter Nav.
 * */

export default {
  init() {

    $('.mobile-filternav').on('click', function() {
      $(this).toggleClass('mobile-filternav--active');
    });

    $('.filter__link').on('click', function() {
      $('.filter__link').removeClass('active');
      $(this).addClass('active');
    });

    $('.filter__link--mobile').on('click', function() {
      $('.mobile-filternav__title span').html($(this).text());
    });

  },
}



// WEBPACK FOOTER //
// ./scripts/lib/mobile-filter-nav.js